import React, { Component } from "react";
import {
  InputGroup,
  FormControl,
  Form,
  FormGroup,
  Checkbox,
  Radio,
} from "react-bootstrap";
import Select from "react-select";
import TimeStamp from "react-timestamp";

import _, { each } from "lodash";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import "../../assets/css/hoverbutton.css";

// No data found
import NoDataFound from "../Errors/NoDataFound";
// Loading
import Loading from "../../components/Loading/Loading";
// Authorization
import withAuthorization from "../../components/Authorization/withAuthorization";
// Firebase
import { fire, auth } from "../../firebase/index";

import paginationFactory from "react-bootstrap-table2-paginator";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  ExportCSVButton,
} from "react-bootstrap-table";
import "../../routes/app";

import { customLog } from "../../variables/Variables";
import { Feature } from "react-mapbox-gl";

import { Modal } from "react-bootstrap";
import AuditTrailGuide from "../Tutorial/AuditTrailGuide";

// Images
import Bluetooth from "../../assets/img/Bluetooth.png";
import FOBTag from "../../assets/img/FOBTag.png";
import LockedBy from "../../assets/img/LockedBy.png";
import UnlockedBy from "../../assets/img/UnlockedBy.png";
import UnlockByPasscode from "../../assets/img/UnlockByPasscode.png";

import Multiselect from "react-widgets/lib/Multiselect";
import DateTimePicker from "react-widgets/lib/DateTimePicker";
import DropdownMultiselect from "react-multiselect-dropdown-bootstrap";
import DatePicker from "react-datepicker";
import { CSVLink } from "react-csv";
import { ExportToCsv } from "export-to-csv";
import { saveAs } from "file-saver";
import { JSZip, JSZipUtils } from "jszip";
import { ClipLoader } from "react-spinners";

import LocalizedStrings from "react-localization";
import { Label, LabelGroup, Input } from "semantic-ui-react";
import { INTENT_PRIMARY } from "@blueprintjs/core/lib/esm/common/classes";

let localizationStrings = new LocalizedStrings({
  en: {
    auditTrailTitle: "Audit Trail",
    detailsDesc: "These are your lock details",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    userEmailHeader: "User Email",
    tagNameHeader: "Tag Name",
    tagIdHeader: "Tag ID",
    methodHeader: "Method",
    passcodeNameHeader: "Passcode Name",
    lockStatusHeader: "Lock Status",
    dateTimeHeader: "Date Time",
    addressHeader: "Address",
    lockAuditTab: "Mobile Audit",
    tagAuditTab: "Tag Audit",
    mergeAuditTab: "Merge Audit",
    auditTrailGuide: "Audit Trail",
    exportCSVButtonTitle: "Export CSV",
    exportCSVtitle: "Export Data",
    noDataTitle: "There is no data to display",
    locked: "LOCKED",
    unlocked: "UNLOCKED",
    searchTitle: "Search By Email",
    dropdownLabel: "2. Select your Lock Serial :",
    dropdownTitle: "-Select your Lock Serial-",
    superadmindropdownLabel: "1. Select Lock Admin :",
    superadmindropdownTitle: "-Select Lock Admin-",
    showAllTitle: "Show All",
    exportCSVlockLabel: "1. Select Lock Serial for export :",
    exportCSVlockSubLabel: "You may select up to 20 lock serials at once.",
    lockSerialNo: "Lock Serial No.",
    lockName: "Lock Name",
    exportCSVdurationLabel: "2. Select Duration for export :",
    durationDropDownTitle: "-Select Duration-",
    lifetime: "Lifetime",
    lastyear: "Last year",
    last6months: "Last 6 months",
    last3months: "Last 3 months",
    last30days: "Last 30 days",
    last7days: "Last 7 days",
    last3days: "Last 3 days",
    today: "Today",
    cancelButton: "Cancel",
    noDataAvailable:
      "There is no data available for the time duration you have selected for",
    exportCSVerror1: "Please select Lock Serial and Time Duration for export",
    exportCSVerror2: "Please select Lock Serial for export",
    exportCSVerror3: "Please select Time Duration for export",
    exportCSVerror4: "Unable to export data, Please try again",
    exportCSVdataTitle: "AUDIT TRAIL",
    noAddress: "No Address Found",
    CSVBluetooth: "Phone bluetooth",
    CSVMethodTag: "Tag",
    CSVMethodPasscodeLocked: "Lock manually",
    CSVMethodPasscodeUnlocked: "Passcode",
  },
  ja: {
    auditTrailTitle: "アクセス履歴一覧",
    detailsDesc: "登録ハードウェアのアクセス履歴",
    resultTitle1: "表示 ",
    resultTitle2: " へ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    userEmailHeader: "Email",
    tagNameHeader: "NFC名称",
    tagIdHeader: "NFC ID",
    methodHeader: "接続(Bluetooth / NFC / コード)",
    passcodeNameHeader: "名称",
    lockStatusHeader: "施錠・解錠ログ",
    dateTimeHeader: "日時",
    addressHeader: "ロケーション（住所)",
    lockAuditTab: "ロック監査",
    tagAuditTab: "タグ監査",
    mergeAuditTab: "マージ監査",
    auditTrailGuide: "アクセス履歴一覧",
    exportCSVButtonTitle: "CSV出力",
    exportCSVtitle: "出力日",
    noDataTitle: "表示するデータがありません。",
    locked: "施錠",
    unlocked: "解錠",
    searchTitle: "Eメール検索",
    dropdownLabel: "2. シリアルNo選択 :",
    dropdownTitle: "-シリアルNo選択-",
    superadmindropdownLabel: "1. 管理者を選択 :",
    superadmindropdownTitle: "-管理者を選択-",
    showAllTitle: "全データ",
    exportCSVlockLabel: "1. データ出力するロックを選択 :",
    exportCSVlockSubLabel: "1度の出力で上限20台まで選択できます。",
    lockSerialNo: "シリアルNo",
    lockName: "ロックの名前（任意）",
    exportCSVdurationLabel: "2. 集計期間を選択 :",
    durationDropDownTitle: "-集計期間-",
    lifetime: "過去全データ（本日含む）",
    lastyear: "昨年1年間",
    last6months: "本日含め過去6ヶ月",
    last3months: "本日含め3ヶ月間",
    last30days: "本日含め過去３０日間",
    last7days: "本日含め過去７日間",
    last3days: "本日含め過去３日間",
    today: "本日",
    cancelButton: "キャンセル",
    noDataAvailable: "選択した期間内のアクセスデータはありません。",
    exportCSVerror1: "ロックのシリアルNoと出力期間を選択して下さい。",
    exportCSVerror2: "ロックのシリアルNoを選択して下さい。",
    exportCSVerror3: "出力期間を選択して下さい。",
    exportCSVerror4: "出力が行われませんでした。再度、出力設定を行って下さい。",
    exportCSVdataTitle: "アクセス履歴一覧",
    noAddress: "データがありません。",
    CSVBluetooth: "Bluetooth",
    CSVMethodTag: "NFC",
    CSVMethodPasscodeLocked: "手動施錠",
    CSVMethodPasscodeUnlocked: "パスコード",
  },
  es: {
    auditTrailTitle: "Registro de Auditoría",
    detailsDesc: "Estos son los detalles de tu candado",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    userEmailHeader: "Correo Electrónico del Usuario",
    tagNameHeader: "Nombre de la Etiqueta",
    tagIdHeader: "ID de la Etiqueta",
    methodHeader: "Método",
    passcodeNameHeader: "Nombre del Código de Acceso",
    lockStatusHeader: "Estado de la Candado",
    dateTimeHeader: "Fecha y Hora",
    addressHeader: "Dirección",
    lockAuditTab: "Auditoría Móvil",
    tagAuditTab: "Auditoría de Etiquetas",
    mergeAuditTab: "Auditoría de Fusión",
    auditTrailGuide: "Registro de Auditoría",
    exportCSVButtonTitle: "Exportar CSV",
    exportCSVtitle: "Exportar Datos",
    noDataTitle: "No hay datos para mostrar",
    locked: "CERRADO",
    unlocked: "ABIERTO",
    searchTitle: "Buscar Correo Electrónico",
    dropdownLabel: "2. Selecciona tu Número de Serie de la Candado:",
    dropdownTitle: "-Selecciona tu Número de Serie de la Candado-",
    superadmindropdownLabel: "1. Selecciona el Administrador de la Candado:",
    superadmindropdownTitle: "-Selecciona el Administrador de la Candado-",
    showAllTitle: "Mostrar Todos",
    exportCSVlockLabel:
      "1. Selecciona el Número de Serie de la Candado para exportar:",
    exportCSVlockSubLabel:
      "Puedes seleccionar hasta 20 números de serie de candados a la vez.",
    lockSerialNo: "Número de Serie de la Candado",
    lockName: "Nombre de la Candado",
    exportCSVdurationLabel: "2. Selecciona la Duración para exportar:",
    durationDropDownTitle: "-Selecciona la Duración-",
    lifetime: "Vida Útil",
    lastyear: "Último Año",
    last6months: "Últimos 6 Meses",
    last3months: "Últimos 3 Meses",
    last30days: "Últimos 30 Días",
    last7days: "Últimos 7 Días",
    last3days: "Últimos 3 Días",
    today: "Hoy",
    cancelButton: "Cancelar",
    noDataAvailable:
      "No hay datos disponibles para la duración de tiempo que has seleccionado para",
    exportCSVerror1:
      "Por favor selecciona el Número de Serie de la Candado y la Duración de Tiempo para exportar",
    exportCSVerror2:
      "Por favor selecciona el Número de Serie de la Candado para exportar",
    exportCSVerror3: "Por favor selecciona la Duración de Tiempo para exportar",
    exportCSVerror4:
      "No se pudo exportar los datos, por favor intenta de nuevo",
    exportCSVdataTitle: "REGISTRO DE AUDITORÍA",
    noAddress: "No se Encontró Dirección",
    CSVBluetooth: "Bluetooth",
    CSVMethodTag: "NFC",
    CSVMethodPasscodeLocked: "Candado manualmente",
    CSVMethodPasscodeUnlocked: "Código de Acceso",
  },
});

const override = {
  display: "block",
  margin: "0 auto",
};

class AuditTrail extends Component {
  constructor(props) {
    super(props);

    this.detectOnChangeEvent = this.detectOnChangeEvent.bind(this); // kept (not used now)
    this._didBootstrapSuperAdminLocks = false;
    this.fetchSelectedATData = this.fetchSelectedATData.bind(this);
    this.forceUpdateHandler = this.forceUpdateHandler.bind(this);

    this.statusFormat = this.statusFormat.bind(this);
    this.methodFormat = this.methodFormat.bind(this);

    this.dateTimeFormat = this.dateTimeFormat.bind(this);
    this.dateTimeFormatCSV = this.dateTimeFormatCSV.bind(this);

    this.createCustomSearchField = this.createCustomSearchField.bind(this);

    this.lockButtonClick = this.lockButtonClick.bind(this);
    this.tagButtonClick = this.tagButtonClick.bind(this);
    this.mergedButtonClick = this.mergedButtonClick.bind(this);
    this.handleExportCSVButtonClick = this.handleExportCSVButtonClick.bind(
      this
    );
    this.handleExportCSVPopupClose = this.handleExportCSVPopupClose.bind(this);
    this.handleRadioAll = this.handleRadioAll.bind(this);
    this.handleRadioCustom = this.handleRadioCustom.bind(this);
    this.conditionRendering = this.conditionRendering.bind(this);
    this.handleSelectedLocks = this.handleSelectedLocks.bind(this);
    this.fetchSelectedLocksExport = this.fetchSelectedLocksExport.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.detectDateFilterOnChangeEvent = this.detectDateFilterOnChangeEvent.bind(
      this
    );
    this.handleExportCSV = this.handleExportCSV.bind(this);
    this.createCustomExportCSVButton = this.createCustomExportCSVButton.bind(
      this
    );

    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);

    this.placemarkCSV = this.placemarkCSV.bind(this);
    this.renderEmailDropdown = this.renderEmailDropdown.bind(this);

    this.state = {
      myadminlocklistArray: [],
      mysuperadminlocklistArray: [],
      memberemaillistArray: [],
      atArray: [],
      tagDataArray: [],
      directionalPCDataArray: [],
      mergedDataArray: [],
      loading: true,

      // NEW: loading only for lock list after selecting admin
      loadingAdminLocks: false,

      selectedLockSerial: "",
      selectedLockModel: "",
      isPaymentValid: false,
      isAdmin: false,
      isSuperAdmin: false,
      isShowingTags: false,
      isShowingLocks: false,
      showPopup: false,
      popupTitle: "",
      popupImage: [],
      showExportCSVPopup: false,

      value: null, // selected lock serial (react-select)
      emailvalue: "all",

      startDate: new Date(),
      endDate: new Date(),
      exportDuration: 0,
      selectedDuration: false,
      viewLock: "",
      selectedLock: [],
      emptyArray: [],
      calendarStartText: "Select your start date",
      calendarEndText: "Select your end date",
      radioAllChecked: true,
      radioCustomChecked: false,
      atArrayCSV: [],
      tagDataArrayCSV: [],
      directionalPCDataArrayCSV: [],
      mergedDataArrayCSV: [],

      _notificationSystem: null,
    };
  }

  componentWillMount() {
    // Admin's own locks
    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        var LockArr = [];
        snapshot.forEach((snapshotData) => {
          if (snapshotData.val().Name !== undefined) {
            LockArr.push({
              ip45SerialNumber: snapshotData.val().ip45SerialNumber,
              lockAlias: snapshotData.val().Name,
              lockModel: snapshotData.val().Type,
              lockName:
                snapshotData.val().ip45SerialNumber +
                " - " +
                snapshotData.val().Name,
            });
          } else {
            LockArr.push({
              ip45SerialNumber: snapshotData.val().ip45SerialNumber,
              lockAlias: snapshotData.val().Name,
              lockModel: snapshotData.val().Type,
              lockName: snapshotData.val().ip45SerialNumber,
            });
          }
        });

        this.setState({
          myadminlocklistArray: LockArr,
          loading: false,
        });
      })
      .catch((err) => {
        customLog(err);
      });

    // Member list (for superadmin view grouping)
    fire
      .database()
      .ref("groupAccounts")
      .child(auth.currentUser.uid)
      .child("members")
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        var memberEmailArr = [];
        tempArray = this.snapshotToArray(snapshot);
        tempArray.forEach((e) => {
          if (e.isAdmin === true) memberEmailArr.push(e.memberEmail);
        });

        this.setState({ memberemaillistArray: memberEmailArr });
      });

    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({ currentLanguage: snapshot.val() });
        });
    }
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((eachSuperAdmin) => {
            const superAdminDetails = eachSuperAdmin.val();
            const members = superAdminDetails.members;

            for (const eachMembers in members) {
              const memberDetails = members[eachMembers];
              if (memberDetails.memberEmail === auth.currentUser.email) {
                const paymentDetails = superAdminDetails.payment.isPaymentValid;
                this.setState({
                  isAdmin: memberDetails.isAdmin,
                  isSuperAdmin: memberDetails.isSuperAdmin,
                  isPaymentValid: paymentDetails,
                  loading: false,
                });
              }
            }
          });
        }
      });
  }

  bootstrapSuperAdminLocks = async () => {
    if (this._didBootstrapSuperAdminLocks) return;
    this._didBootstrapSuperAdminLocks = true;

    this.setState({
      emailvalue: "all",
      mysuperadminlocklistArray: [],
      value: null,
      selectedLockSerial: "",
      selectedLockModel: "",
      viewLock: "",
      radioAllChecked: true,
      radioCustomChecked: false,
      loadingAdminLocks: true,
    });

    // clear table while loading
    await this.fetchSelectedATData(0, 0);

    try {
      await this.fetchSelectedEmailData("all");
    } finally {
      this.setState({ loadingAdminLocks: false });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // when role becomes superadmin => auto-fetch "Show All" locks on page load
    if (!prevState.isSuperAdmin && this.state.isSuperAdmin) {
      this.bootstrapSuperAdminLocks();
    }
  }

  showNotification(msg, lvl, position, duration) {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-attention"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  forceUpdateHandler() {
    this.forceUpdate();
  }

  // NEW: when selecting admin email, load locks + show loading
  detectEmailOnChangeEvent = async (event) => {
    const email = event.target.value;

    this.setState({
      emailvalue: email,
      mysuperadminlocklistArray: [],
      value: null,
      selectedLockSerial: "",
      selectedLockModel: "",
      viewLock: "",
      radioAllChecked: true,
      radioCustomChecked: false,
      loadingAdminLocks: true,
    });

    // reset table data while loading
    this.fetchSelectedATData(0, 0);

    try {
      await this.fetchSelectedEmailData(email);
    } finally {
      this.setState({ loadingAdminLocks: false });
    }
  };

  // helper: fetch locks belonging to an admin email (returns array)
  fetchLocksForMemberEmail = async (memberEmail) => {
    const emailSnap = await fire
      .database()
      .ref("registeredUsersOnPlatform")
      .orderByValue()
      .equalTo(memberEmail)
      .once("value");

    if (!emailSnap.exists()) return [];

    const memberUID = Object.keys(emailSnap.val())[0];

    const locksSnap = await fire
      .database()
      .ref("userLocks")
      .child(memberUID)
      .once("value");

    const locks = [];
    if (!locksSnap.exists()) return locks;

    locksSnap.forEach((adminlockData) => {
      const v = adminlockData.val() || {};
      const serial = v.ip45SerialNumber;
      if (!serial) return;

      locks.push({
        ip45SerialNumber: serial,
        lockAlias: v.Name,
        lockModel: v.Type,
        lockName: v.Name ? `${serial} - ${v.Name}` : `${serial}`,
        memberEmail,
      });
    });

    return locks;
  };

  // REPLACED: properly await so loading indicator is correct
  fetchSelectedEmailData = async (selectedEmailAdd) => {
    if (selectedEmailAdd !== "all") {
      const locks = await this.fetchLocksForMemberEmail(selectedEmailAdd);
      this.setState({ mysuperadminlocklistArray: locks });
      return;
    }

    const membersSnap = await fire
      .database()
      .ref("groupAccounts")
      .child(auth.currentUser.uid)
      .child("members")
      .orderByKey()
      .once("value");

    const membersArr = this.snapshotToArray(membersSnap) || [];
    const adminEmails = _.uniq(
      membersArr
        .filter((m) => m && m.isAdmin === true)
        .map((m) => m.memberEmail)
    );

    const lockGroups = await Promise.all(
      adminEmails.map((email) => this.fetchLocksForMemberEmail(email))
    );

    this.setState({
      mysuperadminlocklistArray: lockGroups.flat(),
      memberemaillistArray: adminEmails,
    });
  };

  // NEW: react-select lock serial change handler (searchable)
  handleLockSerialSelectChange = async (option) => {
    if (!option) {
      this.setState({
        value: null,
        viewLock: "",
        selectedLockModel: "",
        radioAllChecked: true,
        radioCustomChecked: false,
      });
      this.fetchSelectedATData(0, 0);
      return;
    }

    const lockSerial = option.value;
    const selectedLockModel = Number(option.lockModel);

    this.setState({
      value: lockSerial,
      viewLock: option.label,
      selectedLockModel: selectedLockModel,
      radioAllChecked: false,
      radioCustomChecked: true,
    });

    await this.fetchSelectedATData(lockSerial, selectedLockModel);
  };

  // kept (old path), not used anymore
  async detectOnChangeEvent(event) {
    const lockSerial = event.target.value;
    this.setState({ value: lockSerial });
  }

  renderEmailDropdown() {
    return _.map(this.state.memberemaillistArray, (lockData) => {
      return (
        <option key={lockData} value={lockData}>
          {lockData}
        </option>
      );
    });
  }

  // NEW: build react-select options for lock serial select (supports grouped)
  getLockSerialOptions() {
    const {
      isSuperAdmin,
      emailvalue,
      memberemaillistArray,
      mysuperadminlocklistArray,
      myadminlocklistArray,
    } = this.state;

    // option factory
    const toOption = (lockData) => ({
      value: lockData.ip45SerialNumber,
      label: lockData.lockName,
      lockModel: lockData.lockModel,
      lockAlias: lockData.lockAlias,
      memberEmail: lockData.memberEmail, // helpful when grouped
    });

    if (!isSuperAdmin) {
      const uniqueLocks = _.uniqBy(myadminlocklistArray, "ip45SerialNumber");
      return uniqueLocks.map(toOption);
    }

    // superadmin: group by admin email when "all"
    if (emailvalue === "all") {
      return memberemaillistArray.map((eachAdminEmail) => {
        const uniqueLocks = _.uniqBy(
          mysuperadminlocklistArray.filter(
            (lockData) => lockData.memberEmail === eachAdminEmail
          ),
          "ip45SerialNumber"
        );

        return {
          label: eachAdminEmail,
          options: uniqueLocks.map(toOption),
        };
      });
    }

    // superadmin: single admin selected -> flat options
    const uniqueLocks = _.uniqBy(mysuperadminlocklistArray, "ip45SerialNumber");
    return uniqueLocks.map(toOption);
  }

  // NEW: find selected option even if options are grouped
  findSelectedOption(options, value) {
    if (!value) return null;
    for (const item of options) {
      if (item && item.options && Array.isArray(item.options)) {
        const found = item.options.find((o) => o.value === value);
        if (found) return found;
      } else if (item && item.value === value) {
        return item;
      }
    }
    return null;
  }

  renderExportDropdown() {
    const {
      isSuperAdmin,
      mysuperadminlocklistArray,
      myadminlocklistArray,
    } = this.state;

    const lockList = isSuperAdmin
      ? mysuperadminlocklistArray
      : myadminlocklistArray;
    const uniqueLocks = _.uniqBy(lockList, "ip45SerialNumber");
    return uniqueLocks.map((lockData) => lockData.ip45SerialNumber);
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="searchBar"
        placeholder={localizationStrings.searchTitle}
      />
    );
  };

  handleExportCSVButtonClick = (onClick) => {
    if (this.state.viewLock != "") {
      if (this.state.isSuperAdmin) {
        _.map(this.state.mysuperadminlocklistArray, (lockData) => {
          if (lockData.lockName === this.state.viewLock) {
            this.setState({ selectedLock: [lockData] });
          }
        });
      } else {
        _.map(this.state.myadminlocklistArray, (lockData) => {
          if (lockData.lockName === this.state.viewLock) {
            this.setState({ selectedLock: [lockData] });
          }
        });
      }

      this.setState({
        showExportCSVPopup: true,
        selectedDuration: false,
        exportDuration: 0,
        radioAllChecked: false,
        radioCustomChecked: true,
      });
    } else {
      this.setState({
        selectedLock: [],
        selectedDuration: false,
        exportDuration: 0,
        showExportCSVPopup: true,
        radioAllChecked: true,
        radioCustomChecked: false,
      });
    }
  };

  handleExportCSVPopupClose() {
    this.setState({
      showExportCSVPopup: false,
      startDate: new Date(),
      endDate: new Date(),
      selectedLock: [],
      selectedDuration: false,
      exportDuration: 0,
    });
  }

  handleRadioAll() {
    this.setState({ radioAllChecked: true, radioCustomChecked: false });
  }
  handleRadioCustom() {
    this.setState({ radioAllChecked: false, radioCustomChecked: true });
  }

  conditionRendering(showLockSerialLists) {
    if (!showLockSerialLists) return;

    if (this.state.selectedLock.length === 20) {
      return this.state.emptyArray;
    } else {
      const lockList = this.state.isSuperAdmin
        ? this.state.mysuperadminlocklistArray
        : this.state.myadminlocklistArray;

      return _.uniqBy(lockList, "ip45SerialNumber");
    }
  }

  handleSelectedLocks(selectedLocks) {
    this.setState({ selectedLock: selectedLocks });
  }

  async fetchSelectedLocksExport(selectedLock, selectedModel) {
    if (this.state.exportDuration != 0) {
      let userId = "";

      if (
        selectedModel !== undefined &&
        (selectedModel === 4 ||
          selectedModel === 10 ||
          selectedModel === 11 ||
          selectedModel === 13)
      ) {
        await fire
          .database()
          .ref("AuditTrail")
          .child(selectedLock)
          .orderByChild("time")
          .startAt(this.state.exportDuration)
          .once("value")
          .then((snapshot) => {
            var tempArray = [];
            snapshot.forEach(function(childSnap) {
              var item = {
                Latitude: childSnap.val().Latitude,
                Longitude: childSnap.val().Longitude,
                Placemark: childSnap.val().Placemark,
                UIDOfUser: childSnap.val().UIDOfUser,
                lockedStatus: childSnap.val().lockedStatus,
                auditTrailTime: childSnap.val().time,
                userEmail: childSnap.val().userEmail,
                method: childSnap.val().lockedStatus.includes("UNLOCKED")
                  ? localizationStrings.CSVBluetooth
                  : childSnap.val().lockedStatus.includes("LOCKED")
                  ? localizationStrings.CSVBluetooth
                  : "N/A",
              };
              userId = item.UIDofUser;
              tempArray.push(item);
            });

            var newArr = tempArray.reverse();
            this.setState({ atArrayCSV: newArr });
          });

        await fire
          .database()
          .ref("tagAuditTrail")
          .child(selectedLock)
          .orderByChild("auditTrailTime")
          .startAt(this.state.exportDuration)
          .once("value")
          .then((snapshot) => {
            var tempArray = [];
            tempArray = this.snapshotToArray(snapshot, "FOB", false, true);
            tempArray.reverse();
            this.setState({ tagDataArrayCSV: tempArray });
          });

        var mergeDataArray = this.state.atArrayCSV.concat(
          this.state.tagDataArrayCSV
        );
        mergeDataArray.sort((a, b) => b.auditTrailTime - a.auditTrailTime);
        this.setState({ mergedDataArrayCSV: mergeDataArray });
      } else if (
        selectedModel !== undefined &&
        (selectedModel === 7 || selectedModel === 8 || selectedModel === 9)
      ) {
        await fire
          .database()
          .ref("AuditTrail")
          .child(selectedLock)
          .orderByChild("time")
          .startAt(this.state.exportDuration)
          .once("value")
          .then((snapshot) => {
            var tempArray = [];
            snapshot.forEach(function(childSnap) {
              var item = {
                Latitude: childSnap.val().Latitude,
                Longitude: childSnap.val().Longitude,
                Placemark: childSnap.val().Placemark,
                UIDOfUser: childSnap.val().UIDOfUser,
                lockedStatus: childSnap.val().lockedStatus,
                auditTrailTime: childSnap.val().time,
                userEmail: childSnap.val().userEmail,
                method: childSnap.val().lockedStatus.includes("UNLOCKED")
                  ? localizationStrings.CSVBluetooth
                  : childSnap.val().lockedStatus.includes("LOCKED")
                  ? localizationStrings.CSVBluetooth
                  : "N/A",
              };
              userId = item.UIDofUser;
              tempArray.push(item);
            });

            var newArr = tempArray.reverse();
            this.setState({ atArrayCSV: newArr });
          });

        await fire
          .database()
          .ref("directionalPassCodeAuditTrail")
          .child(selectedLock)
          .orderByChild("auditTrailTime")
          .startAt(this.state.exportDuration)
          .once("value")
          .then((snapshot) => {
            var tempArray = [];
            tempArray = this.snapshotToArray(snapshot, "Passcode", false, true);
            tempArray.reverse();
            this.setState({ directionalPCDataArrayCSV: tempArray });
          });

        var mergeDataArray = this.state.atArrayCSV.concat(
          this.state.directionalPCDataArrayCSV
        );

        mergeDataArray.sort((a, b) => b.auditTrailTime - a.auditTrailTime);
        this.setState({ mergedDataArrayCSV: mergeDataArray });
      }
    } else {
      let userId = "";

      if (
        selectedModel !== undefined &&
        (selectedModel === 4 ||
          selectedModel === 10 ||
          selectedModel === 11 ||
          selectedModel === 13)
      ) {
        await fire
          .database()
          .ref("AuditTrail")
          .child(selectedLock)
          .once("value")
          .then((snapshot) => {
            var tempArray = [];
            snapshot.forEach(function(childSnap) {
              var item = {
                Latitude: childSnap.val().Latitude,
                Longitude: childSnap.val().Longitude,
                Placemark: childSnap.val().Placemark,
                UIDOfUser: childSnap.val().UIDOfUser,
                lockedStatus: childSnap.val().lockedStatus,
                auditTrailTime: childSnap.val().time,
                userEmail: childSnap.val().userEmail,
                method: childSnap.val().lockedStatus.includes("UNLOCKED")
                  ? localizationStrings.CSVBluetooth
                  : childSnap.val().lockedStatus.includes("LOCKED")
                  ? localizationStrings.CSVBluetooth
                  : "N/A",
              };
              userId = item.UIDofUser;
              tempArray.push(item);
            });

            var newArr = tempArray.reverse();
            this.setState({ atArrayCSV: newArr });
          });

        await fire
          .database()
          .ref("tagAuditTrail")
          .child(selectedLock)
          .orderByChild("auditTrailTime")
          .once("value")
          .then((snapshot) => {
            var tempArray = [];
            tempArray = this.snapshotToArray(snapshot, "FOB", false, true);
            tempArray.reverse();
            this.setState({ tagDataArrayCSV: tempArray });
          });

        var mergeDataArray = this.state.atArrayCSV.concat(
          this.state.tagDataArrayCSV
        );
        mergeDataArray.sort((a, b) => b.auditTrailTime - a.auditTrailTime);
        this.setState({ mergedDataArrayCSV: mergeDataArray });
      } else if (
        selectedModel !== undefined &&
        (selectedModel === 7 || selectedModel === 8 || selectedModel === 9)
      ) {
        await fire
          .database()
          .ref("AuditTrail")
          .child(selectedLock)
          .once("value")
          .then((snapshot) => {
            var tempArray = [];
            snapshot.forEach(function(childSnap) {
              var item = {
                Latitude: childSnap.val().Latitude,
                Longitude: childSnap.val().Longitude,
                Placemark: childSnap.val().Placemark,
                UIDOfUser: childSnap.val().UIDOfUser,
                lockedStatus: childSnap.val().lockedStatus,
                auditTrailTime: childSnap.val().time,
                userEmail: childSnap.val().userEmail,
                method: childSnap.val().lockedStatus.includes("UNLOCKED")
                  ? localizationStrings.CSVBluetooth
                  : childSnap.val().lockedStatus.includes("LOCKED")
                  ? localizationStrings.CSVBluetooth
                  : "N/A",
              };
              userId = item.UIDofUser;
              tempArray.push(item);
            });

            var newArr = tempArray.reverse();
            this.setState({ atArrayCSV: newArr });
          });

        await fire
          .database()
          .ref("directionalPassCodeAuditTrail")
          .child(selectedLock)
          .orderByChild("auditTrailTime")
          .once("value")
          .then((snapshot) => {
            var tempArray = [];
            tempArray = this.snapshotToArray(snapshot, "Passcode", false, true);
            tempArray.reverse();
            this.setState({ directionalPCDataArrayCSV: tempArray });
          });

        var mergeDataArray = this.state.atArrayCSV.concat(
          this.state.directionalPCDataArrayCSV
        );

        mergeDataArray.sort((a, b) => b.auditTrailTime - a.auditTrailTime);
        this.setState({ mergedDataArrayCSV: mergeDataArray });
      }
    }
  }

  async handleStartDateChange(startDate) {
    await this.setState({
      startDate: startDate,
      calendarStartText: startDate.toString(),
    });
  }

  async handleEndDateChange(endDate) {
    await this.setState({
      endDate: endDate,
      calendarEndText: endDate.toString(),
    });
  }

  detectDateFilterOnChangeEvent(event) {
    var days = 0;
    var months = 0;
    var isLifeTimeSelected = false;
    switch (event.target.value) {
      case "lifetime":
        isLifeTimeSelected = true;
        break;
      case "lastyear":
        months = 12;
        break;
      case "6months":
        months = 6;
        break;
      case "3months":
        months = 3;
        break;
      case "30days":
        days = 30;
        break;
      case "7days":
        days = 7;
        break;
      case "3days":
        days = 3;
        break;
      case "today":
        days = 0;
        break;
      default:
        break;
    }

    var date = new Date();
    date.setHours(0, 0, 0, 0);
    var last = 0;

    if (isLifeTimeSelected) {
      // Lifetime => last stays 0
    } else if (months != 0) {
      last = date.setMonth(date.getMonth() - months);
    } else {
      last = date.getTime() - days * 24 * 60 * 60 * 1000;
    }

    this.setState({
      exportDuration: last,
      selectedDuration: true,
    });
  }

  async handleExportCSV() {
    if (
      this.state.selectedLock != "" &&
      this.state.selectedDuration !== false
    ) {
      for (var i = 0; i < this.state.selectedLock.length; i++) {
        var eachSelectedLock = this.state.selectedLock[i];

        await this.fetchSelectedLocksExport(
          eachSelectedLock.ip45SerialNumber,
          eachSelectedLock.lockModel
        );

        const csvlockdata = _.map(this.state.atArrayCSV, (atData) => {
          var japanDate =
            new Intl.DateTimeFormat("ja-JP", { year: "numeric" }).format(
              atData.auditTrailTime
            ) +
            new Intl.DateTimeFormat("ja-JP", { month: "numeric" }).format(
              atData.auditTrailTime
            ) +
            new Intl.DateTimeFormat("ja-JP", { day: "numeric" }).format(
              atData.auditTrailTime
            );
          var japanTime = new Intl.DateTimeFormat("ja-JP", {
            hourCycle: "h12",
            hour: "numeric",
            minute: "2-digit",
          }).format(atData.auditTrailTime);

          var dateTime = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          }).format(atData.auditTrailTime);

          return {
            [localizationStrings.userEmailHeader]: atData.userEmail,
            [localizationStrings.tagIdHeader]: "N/A",
            [localizationStrings.lockStatusHeader]:
              atData.lockedStatus === "LOCKED"
                ? localizationStrings.locked
                : localizationStrings.unlocked,
            [localizationStrings.dateTimeHeader]:
              localizationStrings.getLanguage() === "ja"
                ? japanDate + " " + japanTime
                : dateTime,
            [localizationStrings.addressHeader]: atData.Placemark
              ? atData.Placemark
              : localizationStrings.noAddress,
          };
        });

        const csvtagdata = _.map(this.state.tagDataArrayCSV, (atData) => {
          var japanDate =
            new Intl.DateTimeFormat("ja-JP", { year: "numeric" }).format(
              atData.auditTrailTime
            ) +
            new Intl.DateTimeFormat("ja-JP", { month: "numeric" }).format(
              atData.auditTrailTime
            ) +
            new Intl.DateTimeFormat("ja-JP", { day: "numeric" }).format(
              atData.auditTrailTime
            );
          var japanTime = new Intl.DateTimeFormat("ja-JP", {
            hourCycle: "h12",
            hour: "numeric",
            minute: "2-digit",
          }).format(atData.auditTrailTime);

          var dateTime = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          }).format(atData.auditTrailTime);

          return {
            [localizationStrings.tagNameHeader]: !atData.tagName
              ? "N/A"
              : atData.tagName,
            [localizationStrings.tagIdHeader]: atData.tagId,
            [localizationStrings.methodHeader]: atData.method,
            [localizationStrings.lockStatusHeader]:
              localizationStrings.unlocked,
            [localizationStrings.dateTimeHeader]:
              localizationStrings.getLanguage() === "ja"
                ? japanDate + " " + japanTime
                : dateTime,
            [localizationStrings.addressHeader]: "N/A",
          };
        });

        const csvpasscodedata = _.map(
          this.state.directionalPCDataArrayCSV,
          (atData) => {
            var japanDate =
              new Intl.DateTimeFormat("ja-JP", { year: "numeric" }).format(
                atData.auditTrailTime
              ) +
              new Intl.DateTimeFormat("ja-JP", { month: "numeric" }).format(
                atData.auditTrailTime
              ) +
              new Intl.DateTimeFormat("ja-JP", { day: "numeric" }).format(
                atData.auditTrailTime
              );

            var japanTime = new Intl.DateTimeFormat("ja-JP", {
              hourCycle: "h12",
              hour: "numeric",
              minute: "2-digit",
            }).format(atData.auditTrailTime);

            var dateTime = new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            }).format(atData.auditTrailTime);

            return {
              [localizationStrings.passcodeNameHeader]: !atData.passcodeName
                ? "N/A"
                : atData.passcodeName,
              [localizationStrings.methodHeader]: atData.method,
              [localizationStrings.lockStatusHeader]:
                localizationStrings.unlocked,
              [localizationStrings.dateTimeHeader]:
                localizationStrings.getLanguage() === "ja"
                  ? japanDate + " " + japanTime
                  : dateTime,
              [localizationStrings.addressHeader]: "N/A",
            };
          }
        );

        const csvmergeddata = _.map(this.state.mergedDataArrayCSV, (atData) => {
          var japanDate =
            new Intl.DateTimeFormat("ja-JP", { year: "numeric" }).format(
              atData.time || atData.auditTrailTime
            ) +
            new Intl.DateTimeFormat("ja-JP", { month: "numeric" }).format(
              atData.time || atData.auditTrailTime
            ) +
            new Intl.DateTimeFormat("ja-JP", { day: "numeric" }).format(
              atData.time || atData.auditTrailTime
            );

          var japanTime = new Intl.DateTimeFormat("ja-JP", {
            hourCycle: "h12",
            hour: "numeric",
            minute: "2-digit",
          }).format(atData.time || atData.auditTrailTime);

          var dateTime = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          }).format(atData.time || atData.auditTrailTime);

          var lockStatus =
            atData.lockedStatus === "LOCKED"
              ? localizationStrings.locked
              : localizationStrings.unlocked;

          if (
            eachSelectedLock.lockModel === 4 ||
            eachSelectedLock.lockModel === 10 ||
            eachSelectedLock.lockModel === 11 ||
            eachSelectedLock.lockModel === 13
          ) {
            return {
              [localizationStrings.userEmailHeader]: atData.tagId
                ? "N/A"
                : atData.userEmail,
              [localizationStrings.tagNameHeader]: !atData.tagName
                ? "N/A"
                : atData.tagName,
              [localizationStrings.tagIdHeader]: atData.tagId
                ? atData.tagId
                : "N/A",
              [localizationStrings.methodHeader]: atData.method,
              [localizationStrings.lockStatusHeader]: atData.lockedStatus
                ? lockStatus
                : localizationStrings.unlocked,
              [localizationStrings.dateTimeHeader]:
                localizationStrings.getLanguage() === "ja"
                  ? japanDate + " " + japanTime
                  : dateTime,
              [localizationStrings.addressHeader]: atData.Placemark
                ? atData.Placemark
                : localizationStrings.noAddress,
            };
          } else if (
            eachSelectedLock.lockModel === 7 ||
            eachSelectedLock.lockModel === 8 ||
            eachSelectedLock.lockModel === 9
          ) {
            return {
              [localizationStrings.userEmailHeader]: atData.passcodeName
                ? "N/A"
                : atData.userEmail,
              [localizationStrings.passcodeNameHeader]: !atData.passcodeName
                ? "N/A"
                : atData.passcodeName,
              [localizationStrings.methodHeader]: atData.method,
              [localizationStrings.lockStatusHeader]: atData.lockedStatus
                ? lockStatus
                : localizationStrings.unlocked,
              [localizationStrings.dateTimeHeader]:
                localizationStrings.getLanguage() === "ja"
                  ? japanDate + " " + japanTime
                  : dateTime,
              [localizationStrings.addressHeader]: atData.Placemark
                ? atData.Placemark
                : localizationStrings.noAddress,
            };
          }
          return null;
        }).filter(Boolean);

        const options = {
          filename: `${eachSelectedLock.ip45SerialNumber}${
            eachSelectedLock.lockAlias !== undefined
              ? ` ${eachSelectedLock.lockAlias}`
              : ``
          }`,
          fieldSeparator: ",",
          quoteStrings: '"',
          decimalSeparator: ".",
          showLabels: true,
          showTitle: true,
          title: `${localizationStrings.exportCSVdataTitle} (${eachSelectedLock.lockName})`,
          useTextFile: false,
          useBom: true,
          headers: [],
          useKeysAsHeaders: true,
        };
        const csvExporter = new ExportToCsv(options);

        if (this.state.isShowingLocks) {
          if (csvlockdata != "") {
            csvExporter.generateCsv(csvlockdata);
            this.setState({ showExportCSVPopup: false });
          } else {
            this.showNotification(
              `${localizationStrings.noDataAvailable} ${
                eachSelectedLock.ip45SerialNumber
              }${
                eachSelectedLock.lockAlias !== undefined
                  ? ` - ${eachSelectedLock.lockAlias}`
                  : ``
              }`,
              "error",
              "tc",
              10
            );
          }
        } else if (this.state.isShowingTags) {
          if (csvtagdata != "") {
            csvExporter.generateCsv(csvtagdata);
            this.setState({ showExportCSVPopup: false });
          } else {
            this.showNotification(
              `${localizationStrings.noDataAvailable} ${
                eachSelectedLock.ip45SerialNumber
              }${
                eachSelectedLock.lockAlias !== undefined
                  ? ` - ${eachSelectedLock.lockAlias}`
                  : ``
              }`,
              "error",
              "tc",
              10
            );
          }
        } else {
          if (csvmergeddata != "") {
            csvExporter.generateCsv(csvmergeddata);
            this.setState({ showExportCSVPopup: false });
          } else {
            this.showNotification(
              `${localizationStrings.noDataAvailable} ${
                eachSelectedLock.ip45SerialNumber
              }${
                eachSelectedLock.lockAlias !== undefined
                  ? ` - ${eachSelectedLock.lockAlias}`
                  : ``
              }`,
              "error",
              "tc",
              10
            );
          }
        }
      }
    } else {
      if (
        this.state.selectedLock == "" &&
        this.state.selectedDuration === false
      ) {
        this.showNotification(
          localizationStrings.exportCSVerror1,
          "error",
          "tc",
          5
        );
      } else if (this.state.selectedLock == "") {
        this.showNotification(
          localizationStrings.exportCSVerror2,
          "error",
          "tc",
          5
        );
      } else if (this.state.selectedDuration === false) {
        this.showNotification(
          localizationStrings.exportCSVerror3,
          "error",
          "tc",
          5
        );
      } else {
        this.showNotification(
          localizationStrings.exportCSVerror4,
          "error",
          "tc",
          5
        );
      }
    }
  }

  createCustomExportCSVButton = (onClick) => {
    return (
      <ExportCSVButton
        style={{
          border: "3px solid",
          fontWeight: "bold",
          fontSize: "1em",
        }}
        btnText={localizationStrings.exportCSVButtonTitle}
        className="exportCSVBtn"
        onClick={() => this.handleExportCSVButtonClick(onClick)}
      />
    );
  };

  snapshotToArray = (snapshot, type = "none", merge = false, CSV = false) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;

      if (type != "none" && !merge) {
        let insert;

        if (type === "Bluetooth") {
          if (CSV) {
            insert = {
              Latitude: item.Latitude,
              lockedStatus: item.lockedStatus,
              Longitude: item.longitude,
              Placemark: item.Placemark,
              time: item.time,
              UIDOfUser: item.UIDOfUser,
              userEmail: item.userEmail,
              key: item.key,
              method: item.lockedStatus.includes("UNLOCKED")
                ? localizationStrings.CSVBluetooth
                : item.lockedStatus.includes("LOCKED")
                ? localizationStrings.CSVBluetooth
                : "N/A",
            };
          } else {
            insert = {
              Latitude: item.Latitude,
              lockedStatus: item.lockedStatus,
              Longitude: item.longitude,
              Placemark: item.Placemark,
              time: item.time,
              UIDOfUser: item.UIDOfUser,
              userEmail: item.userEmail,
              key: item.key,
              method: "Bluetooth",
            };
          }
        } else if (type === "FOB") {
          if (CSV) {
            insert = {
              UIDOfUser: item.UIDOfUser,
              auditDeciValue: item.auditDeciValue,
              auditTrailTime: item.auditTrailTime,
              tagId: item.tagId,
              tagName: item.tagName,
              updateTime: item.updateTime,
              userEmail: item.userEmail,
              key: item.key,
              lockedStatus:
                item.auditDeciValue >= 250 && item.auditDeciValue <= 254
                  ? "LOCKED"
                  : "UNLOCKED",
              method:
                item.auditDeciValue >= 250 && item.auditDeciValue <= 254
                  ? localizationStrings.CSVMethodPasscodeLocked
                  : localizationStrings.CSVMethodTag,
            };
          } else {
            insert = {
              UIDOfUser: item.UIDOfUser,
              auditDeciValue: item.auditDeciValue,
              auditTrailTime: item.auditTrailTime,
              tagId: item.tagId,
              tagName: item.tagName,
              updateTime: item.updateTime,
              userEmail: item.userEmail,
              key: item.key,
              method: "FOB",
            };
          }
        } else if (type === "Passcode") {
          if (CSV) {
            insert = {
              UIDOfUser: item.UIDOfUser,
              auditDeciValue: item.auditDeciValue,
              auditTrailTime: item.auditTrailTime,
              directionalPasscode: item.directionalPasscode,
              lockBackTime: item.lockBackTime,
              passcodeName: item.passcodeName,
              updateTime: item.updateTime,
              userEmail: item.userEmail,
              key: item.key,
              lockedStatus:
                item.auditDeciValue >= 250 && item.auditDeciValue <= 254
                  ? "LOCKED"
                  : "UNLOCKED",
              method:
                item.auditDeciValue >= 250 && item.auditDeciValue <= 254
                  ? localizationStrings.CSVMethodPasscodeLocked
                  : localizationStrings.CSVMethodPasscodeUnlocked,
            };
          } else {
            insert = {
              UIDOfUser: item.UIDOfUser,
              auditDeciValue: item.auditDeciValue,
              auditTrailTime: item.auditTrailTime,
              directionalPasscode: item.directionalPasscode,
              lockBackTime: item.lockBackTime,
              passcodeName: item.passcodeName,
              updateTime: item.updateTime,
              userEmail: item.userEmail,
              key: item.key,
              method: "Passcode",
            };
          }
        }

        returnArr.push(insert);
      } else if (merge) {
        let insert;

        if (type === "Passcode") {
          insert = {
            UIDOfUser: item.UIDOfUser,
            auditDeciValue: item.auditDeciValue,
            auditTrailTime: item.auditTrailTime,
            directionalPasscode: item.directionalPasscode,
            lockBackTime: item.lockBackTime,
            passcodeName: item.passcodeName,
            lockedStatus: item.auditDeciValue,
            updateTime: item.updateTime,
            userEmail: item.userEmail,
            key: item.key,
            method: "Passcode",
          };
        } else if (type === "FOB") {
          insert = {
            UIDOfUser: item.UIDOfUser,
            auditDeciValue: item.auditDeciValue,
            auditTrailTime: item.auditTrailTime,
            tagId: item.tagId,
            tagName: item.tagName,
            lockedStatus: item.auditDeciValue,
            updateTime: item.updateTime,
            userEmail: item.userEmail,
            key: item.key,
            method: "FOB",
          };
        }

        returnArr.push(insert);
      } else {
        returnArr.push(item);
      }
    });

    return returnArr;
  };

  async fetchSelectedATData(selectedLockSerial, selectedLockModel) {
    let userId = "";

    if (
      selectedLockModel !== undefined &&
      (selectedLockModel === 4 ||
        selectedLockModel === 10 ||
        selectedLockModel === 11 ||
        selectedLockModel === 13)
    ) {
      await fire
        .database()
        .ref("AuditTrail")
        .child(selectedLockSerial)
        .limitToLast(200)
        .once("value")
        .then((snapshot) => {
          var tempArray = [];
          snapshot.forEach(function(childSnap) {
            var item = childSnap.val();
            let insert = {
              Latitude: item.Latitude,
              lockedStatus: item.lockedStatus,
              Longitude: item.Longitude,
              Placemark: item.Placemark,
              time: item.time,
              UIDOfUser: item.UIDOfUser,
              userEmail: item.userEmail,
              method: "Bluetooth",
            };
            userId = item.UIDofUser;
            tempArray.push(insert);
          });

          var newArr = tempArray.reverse();
          this.setState({ atArray: newArr });
        });

      await fire
        .database()
        .ref("tagAuditTrail")
        .child(selectedLockSerial)
        .orderByChild("auditTrailTime")
        .once("value")
        .then((snapshot) => {
          var tempArray = [];
          tempArray = this.snapshotToArray(snapshot, "FOB");
          tempArray.reverse();
          this.setState({ tagDataArray: tempArray });
        });

      var mergeDataArray = this.state.atArray.concat(this.state.tagDataArray);
      this.setState({ mergedDataArray: mergeDataArray });
      customLog(this.state.mergedDataArray);
    } else if (
      selectedLockModel !== undefined &&
      (selectedLockModel === 7 ||
        selectedLockModel === 8 ||
        selectedLockModel === 9)
    ) {
      await fire
        .database()
        .ref("AuditTrail")
        .child(selectedLockSerial)
        .limitToLast(200)
        .once("value")
        .then((snapshot) => {
          var tempArray = [];
          snapshot.forEach(function(childSnap) {
            var item = childSnap.val();
            let insert = {
              Latitude: item.Latitude,
              lockedStatus: item.lockedStatus,
              Longitude: item.Longitude,
              Placemark: item.Placemark,
              time: item.time,
              UIDOfUser: item.UIDOfUser,
              userEmail: item.userEmail,
              method: "Bluetooth",
            };
            userId = item.UIDofUser;
            tempArray.push(insert);
          });

          var newArr = tempArray.reverse();
          this.setState({ atArray: newArr });
        });

      await fire
        .database()
        .ref("directionalPassCodeAuditTrail")
        .child(selectedLockSerial)
        .orderByChild("auditTrailTime")
        .once("value")
        .then((snapshot) => {
          var tempArray = [];
          tempArray = this.snapshotToArray(snapshot, "Passcode", true);
          tempArray.reverse();
          this.setState({ directionalPCDataArray: tempArray });
        });

      var mergeDataArray = this.state.atArray.concat(
        this.state.directionalPCDataArray
      );
      this.setState({ mergedDataArray: mergeDataArray });
      customLog(this.state.mergedDataArray);
    } else {
      this.setState({
        atArray: [],
        tagDataArray: [],
        directionalPCDataArray: [],
        mergedDataArray: [],
      });
    }
  }

  renderMapBoxMarker() {
    return _.map(this.state.atArray, (atData) => {
      return <Feature coordinates={[atData.Longitude, atData.Latitude]} />;
    });
  }

  // UPDATED: show loading when admin locks are loading too
  loadingData() {
    if (this.state.loading || this.state.loadingAdminLocks) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  sample(latitude, longitude) {
    return latitude + " " + longitude;
  }

  async getAddressFromCoordinates(latitude, longitude) {
    return new Promise((resolve) => {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyAB_TAmajf6cXUpeWmQ6QAgYcQkI8kZkRY`;
      fetch(url)
        .then((res) => res.json())
        .then((resJson) => {
          if (
            resJson &&
            resJson.Response &&
            resJson.Response.View &&
            resJson.Response.View[0] &&
            resJson.Response.View[0].Result &&
            resJson.Response.View[0].Result[0]
          ) {
            resolve(resJson.Response.View[0].Result[0].Location.Address.Label);
          } else {
            resolve();
          }
        })
        .catch(() => resolve());
    });
  }

  placemarkCSV(a) {
    customLog(a);
    if (a.Placemark) {
      return a.Placemark;
    } else {
      return localizationStrings.noAddress;
    }
  }

  placemark(a) {
    if (a.Placemark) {
      const latitude = a.Latitude + "";
      const longitude = a.Longitude + "";
      return (
        <a
          target="_blank"
          rel="noreferrer"
          href={
            "https://www.google.com/maps/search/?api=1&query=" +
            latitude +
            "," +
            longitude
          }
        >
          {a.Placemark}
        </a>
      );
    } else {
      return <a>{localizationStrings.noAddress}</a>;
    }
  }

  methodFormat(method) {
    let imgStyle = {
      height: "70px",
      width: "auto",
    };
    if (method.type === "Bluetooth") {
      if (method.lockStatus.includes("LOCKED")) {
        return <img style={imgStyle} src={Bluetooth} alt="Bluetooth" />;
      } else if (method.lockStatus.includes("UNLOCKED")) {
        return <img style={imgStyle} src={Bluetooth} alt="Bluetooth" />;
      } else if (method.lockStatus.includes("Locked fail")) {
        return <img style={imgStyle} src={UnlockedBy} alt="UnlockedBy" />;
      }
    } else if (method.type === "FOB") {
      if (method.lockStatus >= 250 && method.lockStatus <= 254) {
        return <img style={imgStyle} src={LockedBy} alt="LockedBy" />;
      } else if (method.lockStatus == 249) {
        return <img style={imgStyle} src={FOBTag} alt="FOBTag" />;
      } else {
        return <img style={imgStyle} src={FOBTag} alt="FOBTag" />;
      }
    } else if (method.type === "Passcode") {
      if (method.lockStatus >= 250 && method.lockStatus <= 254) {
        return <img style={imgStyle} src={LockedBy} alt="LockedBy" />;
      } else if (method.lockStatus === 249) {
        return <img style={imgStyle} src={UnlockedBy} alt="UnlockedBy" />;
      } else {
        return (
          <img style={imgStyle} src={UnlockByPasscode} alt="UnlockByPasscode" />
        );
      }
    } else if (method.lockStatus === 249) {
      return <img style={imgStyle} src={UnlockedBy} alt="UnlockedBy" />;
    } else {
      return <img style={imgStyle} src={UnlockedBy} alt="UnlockedBy" />;
    }
  }

  statusFormat(lockStatus) {
    if (lockStatus === "UNLOCKED") {
      return (
        <span className="text-success">{localizationStrings.unlocked}</span>
      );
    } else if (lockStatus === "LOCKED") {
      return <span className="text-danger">{localizationStrings.locked}</span>;
    } else if (lockStatus >= 250 && lockStatus <= 254) {
      return <span className="text-danger">{localizationStrings.locked}</span>;
    } else if (lockStatus === 249) {
      return <span className="text-danger">{localizationStrings.locked}</span>;
    } else {
      return (
        <span className="text-success">{localizationStrings.unlocked}</span>
      );
    }
  }

  dateTimeFormatCSV(time) {
    if (localizationStrings.getLanguage() === "ja") {
      var japanDate =
        new Intl.DateTimeFormat("ja-JP", { year: "numeric" }).format(time) +
        new Intl.DateTimeFormat("ja-JP", { month: "numeric" }).format(time) +
        new Intl.DateTimeFormat("ja-JP", { day: "numeric" }).format(time);

      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(time);

      return japanDate + " " + japanTime;
    } else {
      var dateTime = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }).format(time);

      return dateTime;
    }
  }

  dateTimeFormat(time) {
    if (localizationStrings.getLanguage() === "ja") {
      var japanDate =
        new Intl.DateTimeFormat("ja-JP", { year: "numeric" }).format(time) +
        new Intl.DateTimeFormat("ja-JP", { month: "numeric" }).format(time) +
        new Intl.DateTimeFormat("ja-JP", { day: "numeric" }).format(time);

      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(time);

      return japanDate + " " + japanTime;
    } else {
      return <TimeStamp time={time / 1000} format="full" />;
    }
  }

  lockButtonClick() {
    this.setState({ isShowingLocks: true, isShowingTags: false });
  }
  tagButtonClick() {
    this.setState({ isShowingLocks: false, isShowingTags: true });
  }
  mergedButtonClick() {
    this.setState({ isShowingLocks: false, isShowingTags: false });
  }

  handlePopupOpen() {
    this.setState({
      showPopup: true,
      popupTitle: localizationStrings.auditTrailGuide,
      popupImage: [<AuditTrailGuide />],
    });
  }
  handlePopupClose() {
    this.setState({ showPopup: false });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    // language
    if (this.state.currentLanguage === "en")
      localizationStrings.setLanguage("en");
    else if (this.state.currentLanguage === "ja")
      localizationStrings.setLanguage("ja");
    else if (this.state.currentLanguage === "es")
      localizationStrings.setLanguage("es");

    // react-select options + selected
    const lockSerialOptions = this.getLockSerialOptions();
    const selectedLockOption = this.findSelectedOption(
      lockSerialOptions,
      this.state.value
    );

    const isMergedView =
      !this.state.isShowingLocks && !this.state.isShowingTags;
    const hasSelectedLock = !!this.state.value;
    const modelNum = Number(this.state.selectedLockModel);
    const isIP45Family = [4, 10, 11, 13].includes(modelNum);
    const isLOTOFamily = [7, 8, 9].includes(modelNum);

    // table data
    const auditTrailLockData = _.map(this.state.atArray, (atData) => {
      var address = [];
      address.Latitude = atData.Latitude;
      address.Longitude = atData.Longitude;
      address.Placemark = atData.Placemark;

      return {
        email: atData.userEmail,
        tagId: "N/A",
        status: atData.lockedStatus,
        dateTime: atData.time,
        address: address,
        method: {
          type: atData.method,
          lockedStatus: atData.lockedStatus,
        },
      };
    });

    const auditTrailTagData = _.map(this.state.tagDataArray, (atData) => {
      return {
        tagName: !atData.tagName ? "N/A" : atData.tagName,
        tagId: atData.tagId,
        status: atData.auditDeciValue,
        dateTime: atData.auditTrailTime,
        address: "N/A",
        method: {
          type: atData.method,
          lockStatus: atData.auditDeciValue,
        },
      };
    });

    const auditTrailPasscodeData = _.map(
      this.state.directionalPCDataArray,
      (atData) => {
        return {
          passcodeName: !atData.passcodeName ? "N/A" : atData.passcodeName,
          status: atData.directionalPasscode,
          dateTime: atData.auditTrailTime,
          address: "N/A",
          method: {
            type: atData.method,
            lockStatus: atData.directionalPasscode,
          },
        };
      }
    );

    const auditTrailMergedData = _.map(this.state.mergedDataArray, (atData) => {
      var address = [];
      address.Latitude = atData.Latitude;
      address.Longitude = atData.Longitude;
      address.Placemark = atData.Placemark;

      if (isIP45Family) {
        var tempLockStatus;
        if (atData.auditDeciValue >= 250 && atData.auditDeciValue <= 254) {
          tempLockStatus = "LOCKED";
        } else {
          tempLockStatus = atData.lockedStatus
            ? atData.lockedStatus
            : "UNLOCKED";
        }

        return {
          email: atData.tagId ? "N/A" : atData.userEmail,
          tagName: !atData.tagName ? "N/A" : atData.tagName,
          tagId: atData.tagId ? atData.tagId : "N/A",
          status: tempLockStatus,
          dateTime: atData.time || atData.auditTrailTime,
          address: address ? address : "N/A",
          method: {
            type: atData.method,
            tagId: atData.tagId,
            lockStatus:
              atData.method === "Bluetooth"
                ? atData.lockedStatus
                : atData.method === "FOB"
                ? atData.auditDeciValue
                : atData.method === "Passcode"
                ? atData.auditDeciValue
                : "N.A",
          },
        };
      } else if (isLOTOFamily) {
        return {
          email: atData.passcodeName ? "N/A" : atData.userEmail,
          passcodeName: !atData.passcodeName ? "N/A" : atData.passcodeName,
          status: atData.lockedStatus ? atData.lockedStatus : "UNLOCKED",
          dateTime: atData.time || atData.auditTrailTime,
          address: address ? address : "N/A",
          method: {
            type: atData.method,
            auditDeciValue: atData.auditDeciValue,
            lockStatus:
              atData.method === "Bluetooth"
                ? atData.lockedStatus
                : atData.method === "FOB"
                ? atData.auditDeciValue
                : atData.method === "Passcode"
                ? atData.auditDeciValue
                : "N.A",
          },
        };
      }
      return null;
    }).filter(Boolean);

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    const options = {
      paginationSize: 10,
      pageStartIndex: 1,
      firstPageText: "<<",
      prePageText: "<",
      nextPageText: ">",
      lastPageText: ">>",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationTotalRenderer: customTotal,
      sizePerPageList: [
        { text: "10", value: 10 },
        { text: "100", value: 100 },
        { text: "All", value: auditTrailMergedData.length },
      ],
      searchField: this.createCustomSearchField,
      sortName: "dateTime",
      sortOrder: "desc",
      noDataText: localizationStrings.noDataTitle,
      exportCSVBtn: this.createCustomExportCSVButton,
    };

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    if (!this.state.loading) {
      return (
        <div style={{ maxWidth: "95%", margin: "auto" }}>
          <NotificationSystem ref="notificationSystem" style={style} />

          <div className="header">
            <div className="helpDiv">
              <h2>{localizationStrings.auditTrailTitle}</h2>
            </div>
            <h4>{localizationStrings.detailsDesc}</h4>
          </div>

          <div className="content">
            <div className="header">
              {this.state.isSuperAdmin ? (
                <div className="search">
                  <h5
                    style={{
                      position: "relative",
                      top: "45px",
                      fontSize: "1.3em",
                    }}
                  >
                    {localizationStrings.superadmindropdownLabel}
                  </h5>

                  {/* Admin email dropdown (existing) */}
                  <FormControl
                    style={{
                      width: "40%",
                      position: "relative",
                      top: "40px",
                      marginBottom: "20px",
                      fontSize: "1.2em",
                    }}
                    className="content mediumDropDown"
                    componentClass="select"
                    placeholder="select"
                    onChange={this.detectEmailOnChangeEvent}
                    value={this.state.emailvalue}
                  >
                    <option value={0} disabled>
                      {localizationStrings.superadmindropdownTitle}
                    </option>
                    <option value="all">
                      {localizationStrings.showAllTitle}
                    </option>
                    {this.renderEmailDropdown()}
                  </FormControl>

                  <h5
                    style={{
                      position: "relative",
                      top: "45px",
                      fontSize: "1.3em",
                    }}
                  >
                    {localizationStrings.dropdownLabel}
                  </h5>

                  {/* NEW: searchable lock serial select */}
                  <div
                    style={{
                      width: "40%",
                      position: "relative",
                      top: "40px",
                      marginBottom: "75px",
                      fontSize: "1.2em",
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <Select
                        options={lockSerialOptions}
                        value={selectedLockOption}
                        onChange={this.handleLockSerialSelectChange}
                        isSearchable
                        isClearable
                        isDisabled={this.state.loadingAdminLocks}
                        placeholder={
                          this.state.loadingAdminLocks
                            ? "Loading locks..."
                            : localizationStrings.dropdownTitle
                        }
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "44px",
                            fontSize: "1.05em",
                          }),
                          menu: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>

                    {this.state.loadingAdminLocks ? (
                      <ClipLoader loading size={22} cssOverride={override} />
                    ) : null}
                  </div>
                </div>
              ) : (
                <div
                  className="search"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {/* NEW: searchable lock serial select (admin) */}
                  <div
                    style={{
                      width: "40%",
                      position: "relative",
                      top: "40px",
                      marginBottom: "60px",
                      fontSize: "1.2em",
                    }}
                  >
                    <Select
                      options={lockSerialOptions}
                      value={selectedLockOption}
                      onChange={this.handleLockSerialSelectChange}
                      isSearchable
                      isClearable
                      placeholder={localizationStrings.dropdownTitle}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "44px",
                          fontSize: "1.05em",
                        }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                </div>
              )}

              <BootstrapTable
                keyField="key"
                data={
                  this.state.isShowingLocks
                    ? auditTrailLockData
                    : this.state.isShowingTags
                    ? auditTrailTagData
                    : auditTrailMergedData
                }
                bordered={false}
                options={options}
                search
                noDataIndication={this.loadingData()}
                pagination={paginationFactory(options)}
                exportCSV
              >
                <TableHeaderColumn
                  columnTitle={columnHover}
                  dataField={
                    this.state.isShowingLocks
                      ? "email"
                      : this.state.isShowingTags
                      ? "tagName"
                      : "email"
                  }
                >
                  {this.state.isShowingLocks
                    ? localizationStrings.userEmailHeader
                    : this.state.isShowingTags
                    ? localizationStrings.tagNameHeader
                    : localizationStrings.userEmailHeader}
                </TableHeaderColumn>

                {/* Merged + IP45 family */}
                {isMergedView && hasSelectedLock && isIP45Family ? (
                  <TableHeaderColumn
                    columnTitle={columnHover}
                    dataField="tagName"
                  >
                    {localizationStrings.tagNameHeader}
                  </TableHeaderColumn>
                ) : null}

                {(isMergedView && hasSelectedLock && isIP45Family) ||
                this.state.isShowingTags ? (
                  <TableHeaderColumn
                    columnTitle={columnHover}
                    dataField="tagId"
                  >
                    {localizationStrings.tagIdHeader}
                  </TableHeaderColumn>
                ) : null}

                {/* Merged + LOTO family */}
                {isMergedView && hasSelectedLock && isLOTOFamily ? (
                  <TableHeaderColumn
                    columnTitle={columnHover}
                    dataField="passcodeName"
                  >
                    {localizationStrings.passcodeNameHeader}
                  </TableHeaderColumn>
                ) : null}

                <TableHeaderColumn
                  dataField="method"
                  dataFormat={this.methodFormat}
                >
                  {localizationStrings.methodHeader}
                </TableHeaderColumn>

                <TableHeaderColumn
                  dataField="status"
                  dataFormat={this.statusFormat}
                >
                  {localizationStrings.lockStatusHeader}
                </TableHeaderColumn>

                <TableHeaderColumn
                  dataField="dateTime"
                  dataSort={true}
                  csvFormat={this.dateTimeFormatCSV}
                  dataFormat={this.dateTimeFormat}
                  tdStyle={{ whiteSpace: "normal" }}
                >
                  {localizationStrings.dateTimeHeader}
                </TableHeaderColumn>

                <TableHeaderColumn
                  dataField="address"
                  dataFormat={this.placemark}
                  csvFormat={this.placemarkCSV}
                  tdStyle={{ whiteSpace: "normal" }}
                >
                  {localizationStrings.addressHeader}
                </TableHeaderColumn>
              </BootstrapTable>
            </div>

            <div className="empty-space"></div>
          </div>

          <Modal
            show={this.state.showPopup}
            onHide={this.handlePopupClose}
            dialogClassName="modal-90w"
          >
            <Modal.Header closeButton>
              <Modal.Title>{this.state.popupTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{this.state.popupImage}</Modal.Body>
          </Modal>

          {/* Export CSV Modal (unchanged) */}
          <Modal
            show={this.state.showExportCSVPopup}
            onHide={this.handleExportCSVPopupClose}
            dialogClassName="modal-50w"
          >
            <Modal.Header style={{ paddingLeft: "20px" }} closeButton>
              <Modal.Title>{localizationStrings.exportCSVtitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ padding: "20px 40px" }}>
                <div className="exportCSVpopupDropdown">
                  <h4 style={{ marginTop: "0px", fontSize: "1.6em" }}>
                    {localizationStrings.exportCSVlockLabel}
                  </h4>
                  <p
                    style={{
                      fontFamily: "arial",
                      fontSize: "1.2em",
                      fontWeight: "lighter",
                      marginBottom: "15px",
                      color: "red",
                    }}
                  >
                    {localizationStrings.exportCSVlockSubLabel}
                  </p>

                  <Multiselect
                    style={{ fontSize: "1.2em" }}
                    data={this.conditionRendering(
                      this.state.isSuperAdmin
                        ? this.state.mysuperadminlocklistArray
                        : this.state.myadminlocklistArray
                    )}
                    value={this.state.selectedLock}
                    valueField="lockName"
                    textField="lockName"
                    onChange={this.handleSelectedLocks}
                    placeholder={localizationStrings.dropdownTitle}
                  />

                  <br />
                  <br />
                  <br />

                  <BootstrapTable
                    data={this.state.selectedLock}
                    bordered={true}
                    pagination
                    options={{
                      sizePerPage: 5,
                      hideSizePerPage: true,
                      noDataText: localizationStrings.noDataTitle,
                    }}
                  >
                    <TableHeaderColumn
                      dataField="ip45SerialNumber"
                      isKey={true}
                      tdStyle={{ textAlign: "center" }}
                      thStyle={{ textAlign: "center" }}
                    >
                      {localizationStrings.lockSerialNo}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="lockAlias"
                      tdStyle={{ textAlign: "center" }}
                      thStyle={{ textAlign: "center" }}
                    >
                      {localizationStrings.lockName}
                    </TableHeaderColumn>
                  </BootstrapTable>

                  <div className="exportCSVdateSelection">
                    <h4 style={{ marginTop: "0px", fontSize: "1.6em" }}>
                      {localizationStrings.exportCSVdurationLabel}
                    </h4>

                    <InputGroup style={{ width: "50%", marginBottom: "10px" }}>
                      <InputGroup.Addon
                        style={{
                          border: "1px solid lightgrey",
                        }}
                      >
                        <span
                          style={{ fontSize: "1.8em", fontWeight: "bold" }}
                          data-notify="icon"
                          className="pe-7s-clock"
                        ></span>
                      </InputGroup.Addon>

                      <FormControl
                        style={{ fontSize: "1.2em" }}
                        className="content mediumDropDown"
                        componentClass="select"
                        placeholder="select"
                        defaultValue={0}
                        onChange={this.detectDateFilterOnChangeEvent}
                      >
                        <option value={0} disabled>
                          {localizationStrings.durationDropDownTitle}
                        </option>
                        <option value="lifetime">
                          {localizationStrings.lifetime}
                        </option>
                        <option value="lastyear">
                          {localizationStrings.lastyear}
                        </option>
                        <option value="6months">
                          {localizationStrings.last6months}
                        </option>
                        <option value="3months">
                          {localizationStrings.last3months}
                        </option>
                        <option value="30days">
                          {localizationStrings.last30days}
                        </option>
                        <option value="7days">
                          {localizationStrings.last7days}
                        </option>
                        <option value="3days">
                          {localizationStrings.last3days}
                        </option>
                        <option value="today">
                          {localizationStrings.today}
                        </option>
                      </FormControl>
                    </InputGroup>
                  </div>

                  <br />
                  <br />
                </div>

                <div
                  className="exportCSVpopupButtons"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <button
                    className="exportButton"
                    onClick={this.handleExportCSV}
                  >
                    {localizationStrings.exportCSVtitle}
                  </button>

                  <button
                    className="cancelButton"
                    onClick={this.handleExportCSVPopupClose}
                  >
                    {localizationStrings.cancelButton}
                  </button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div>
          <Loading />
        </div>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(AuditTrail);
